import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const TabListRoot = styled.div<{ $fitContent?: boolean }>`
  position: relative;
  border-bottom: 1px solid ${rawColors.stroke[200]};
  ${({ $fitContent }) =>
    $fitContent
      ? `
    display: inline-flex;
    width: max-content;
    max-width: 100%;
  `
      : ""}
      
`;

export const TabScroller = styled.div<{ $density?: "default" | "compact" }>`
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  min-height: ${({ $density }) => ($density === "compact" ? "26px" : "auto")};
  padding: ${({ $density }) =>
    $density === "compact" ? "0" : `${spacing[2]} ${spacing[3]} 0`};
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const FadeLeft = styled.div<{ $visible: boolean }>`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: ${spacing[4]};
  pointer-events: none;
  background: linear-gradient(
    to right,
    ${rawColors.structural.white} 0%,
    transparent 100%
  );
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.15s ease;
`;

export const FadeRight = styled.div<{ $visible: boolean }>`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: ${spacing[4]};
  pointer-events: none;
  background: linear-gradient(
    to left,
    ${rawColors.structural.white} 0%,
    transparent 100%
  );
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.15s ease;
`;

export const TabButton = styled.button<{
  $isActive: boolean;
  $density?: "default" | "compact";
}>`
  appearance: none;
  background: transparent;
  border: 0;
  padding: ${({ $density }) =>
    $density === "compact"
      ? `0 ${spacing[3]} ${spacing[2]}`
      : `0 ${spacing[2]} ${spacing[2]}`};
  margin: 0;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  white-space: nowrap;
  ${({ $isActive }) =>
    $isActive ? typographyMixin("caption", 3) : typographyMixin("caption", 4)}
  color: ${({ $isActive }) =>
    $isActive ? rawColors.primary[500] : rawColors.text.lowEmphasis};
  transition: color 0.15s ease;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 2px;
    background-color: ${rawColors.primary[500]};
    opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
    transition: opacity 0.15s ease;
  }

  &:hover {
    color: ${({ $isActive }) =>
      $isActive ? rawColors.primary[500] : rawColors.text.highEmphasis};
  }
    
`;
